const $ = require("jquery");

import "jquery-ui";
import "jquery-ui-themes/themes/smoothness/jquery-ui.css";
import "semantic-ui-css/semantic";


$(document).ready(function() {
    //virtaInit();
    const $dimmer = $('.dimmer');
    const $accordion = $('.ui.accordion');
    const $popup = $('.ui.infopopup');
    const $startButton = $('.registration-start');
    const $cancelButton = $('.registration-cancel');
    const $registrationForm = $('.registration.form');
    const $errorMessageContainer = $('.message');

    $accordion.accordion();

    $popup.popup();

    $accordion.find('.title').click(function(e){
        e.preventDefault();
        return false;
    });

    $startButton.click(function(){
        activateAccordionStep(1);
    });

    $cancelButton.click(function(e){
        e.preventDefault();
        activateAccordionStep(0);
    });

    $registrationForm.on('submit', function(e){
        $.ajax({
            url: 'cporegistration.php',
            type: 'post',
            data: $registrationForm.serialize(),
            dataType: 'json',
            beforeSend: function () {
                $dimmer.addClass('active');
            },
            success: function (data) {
                $dimmer.removeClass('active');
                if (data.success === false) {
                    showErrors(data.messages);
                } else {
                    activateAccordionStep(2);
                }
            }
        });
        return false;
    });

    function activateAccordionStep(step) {
        $accordion.accordion('open', step);
    }

    function showErrors(messages) {
        let messageMarkup = '';
        for (let i = 0; i < messages.length; i++) {
            messageMarkup += '<li>' + messages[i] + '</li>';
        }
        $errorMessageContainer.find('.list').html(messageMarkup);
        $errorMessageContainer.removeClass('hidden');
        // Scroll to errors
        $('html, body').animate({
            scrollTop: $errorMessageContainer.offset().top
        }, 500);
    }
});
